<template>
  <div
    class="swiper-slide relative h-full w-90 shrink-0 overflow-hidden transition-500 sm:h-150 sm:rounded-3"
    :class="!story.darkTheme ? 'bg-zinc-900' : 'bg-slate-300'"
  >
    <img v-if="story.fileName" class="h-full w-full object-cover object-top-center" :src="story.fileName" />

    <div
      v-if="story.personName"
      class="absolute left-1/2 top-1/2 w-80 flex flex-col items-center rounded-sm bg-opacity-80 px-5 pb-6 pt-4 -translate-1/2"
      :class="!story.darkTheme ? 'bg-black color-white' : 'bg-white color-zinc-900'"
    >
      <img :src="story.darkTheme ? info.logotip : info.logotip_light" class="max-h-10 max-w-64" />

      <div class="mt-6 text-center text-3xl font-700 tracking-wide">
        {{ story.personName }}
      </div>

      <div class="mt-7 text-center">{{ story.amount ? useLocalize("approved") : useLocalize("specialСonditions") }}</div>

      <div v-if="story.amount" class="mt-4 text-center text-4xl font-700">
        {{ Number(story.amount).toLocaleString("ru") }} {{ info.currency }}
      </div>
    </div>

    <a
      class="absolute bottom-8 left-5% w-90% flex rounded-1.5 bg-main px-2 py-5 font-700 tracking-wide uppercase color-white flex-center sm:bottom-14"
      :href="story.url"
      @click="handleClick"
      @click.middle="handleClick"
    >
      {{
        story.buttonTitle ||
        (cookies.use_alternative_settings && info.alternative_stories_call_to_action) ||
        info.stories_call_to_action ||
        useLocalize("actionButton")
      }}
    </a>

    <button data-button-prev class="absolute bottom-32 left-0 top-9 w-1/2 sm:hidden"></button>
    <button data-button-next class="absolute bottom-32 right-0 top-9 w-1/2 sm:hidden"></button>
  </div>
</template>

<script setup lang="ts">
import type { Story } from "~/types";

const props = defineProps<{ story: Story }>();

const info = getInfo();
const cookies = getCookies();

const handleClick = (event: Event) => {
  void $fetch("/api/stories/story/send-clicks-on-stories", {
    baseURL: "",
    method: "POST",
    body: { story_ids: props.story.id, pre_token: cookies.pre_token },
  });

  if (info.value.vitrina_use && !cookies.prohibit_background_showcase) {
    event.preventDefault();

    window.open(props.story.url, "_blank");

    setTimeout(() => {
      window.location.href = "/vitrina";
    }, 500);
  }
};
</script>

<style scoped>
@media (min-width: 414px) {
  .swiper-slide:not(.swiper-slide-active) {
    opacity: 0.2;
    filter: blur(3px);
    transform: scale(0.8);
  }

  .swiper-slide:not(.swiper-slide-active):hover {
    opacity: 0.4;
    cursor: pointer;
  }
}
</style>
